import ProductListFolder from './ProductListFolder';

export default class ProductList {
	id: string;

	name: string;

	parent: ProductListFolder | null;

	constructor(id: string, name: string, parent: ProductListFolder | null) {
		this.id = id;
		this.name = name;
		this.parent = parent;
	}
}
